import React, { useState } from "react";

/* =========================================================
   MOCK DATA
========================================================= */
const INITIAL_DATA = [
  { id: 1, name: "Aarav Sharma", class: "10-A", roll: "101", status: "Present", date: "2023-10-24" },
  { id: 2, name: "Priya Patel", class: "10-A", roll: "102", status: "Present", date: "2023-10-24" },
  { id: 3, name: "Rohan Gupta", class: "10-A", roll: "103", status: "Absent", date: "2023-10-24" },
  { id: 4, name: "Ananya Singh", class: "10-B", roll: "104", status: "Present", date: "2023-10-24" },
  { id: 5, name: "Kabir Verma", class: "10-B", roll: "105", status: "Late", date: "2023-10-24" },
  { id: 6, name: "Ishita Reddy", class: "10-A", roll: "106", status: "Present", date: "2023-10-24" },
  { id: 7, name: "Arjun Nair", class: "10-C", roll: "107", status: "Absent", date: "2023-10-24" },
  { id: 8, name: "Sneha Joshi", class: "10-C", roll: "108", status: "Present", date: "2023-10-24" },
];

const Attendance = () => {
  const [attendanceData, setAttendanceData] = useState(INITIAL_DATA);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterClass, setFilterClass] = useState("All");
  const [selectedDate, setSelectedDate] = useState("2023-10-24");

  // Filter Logic
  const filteredData = attendanceData.filter((student) => {
    const matchesSearch = student.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          student.roll.includes(searchTerm);
    const matchesClass = filterClass === "All" || student.class === filterClass;
    return matchesSearch && matchesClass;
  });

  // Calculate Stats
  const totalStudents = attendanceData.length;
  const presentCount = attendanceData.filter((s) => s.status === "Present").length;
  const absentCount = attendanceData.filter((s) => s.status === "Absent").length;
  const lateCount = attendanceData.filter((s) => s.status === "Late").length;

  // Toggle Status (Demo interaction)
  const toggleStatus = (id) => {
    setAttendanceData((prev) =>
      prev.map((student) => {
        if (student.id === id) {
          const nextStatus = 
            student.status === "Present" ? "Absent" : 
            student.status === "Absent" ? "Late" : "Present";
          return { ...student, status: nextStatus };
        }
        return student;
      })
    );
  };

  return (
    <>
      {/* 
        =========================================================
        INLINE STYLES 
        (Putting these here so you don't need a separate CSS file)
        =========================================================
      */}
      <style>{`
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
        @import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

        .attendance-page {
          font-family: "Plus Jakarta Sans", sans-serif;
          background-color: #f8fafc;
          min-height: 100vh;
          padding: 40px 20px;
          color: #0f172a;
        }

        .attendance-container {
          max-width: 1100px;
          margin: 0 auto;
        }

        /* ---------- HEADER ---------- */
        .attendance-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }

        .attendance-header h1 {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 6px 0;
          color: #0f172a;
        }

        .attendance-header p {
          margin: 0;
          color: #64748b;
          font-size: 15px;
        }

        .header-actions {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .date-picker {
          padding: 10px 16px;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          background: #ffffff;
          outline: none;
          transition: border-color 0.2s;
        }

        .date-picker:focus {
          border-color: #18181b;
        }

        .btn-primary {
          background: #18181b;
          color: #fff;
          border: none;
          padding: 10px 24px;
          border-radius: 12px;
          font-family: inherit;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }

        .btn-primary:hover {
          background: #27272a;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        /* ---------- STATS CARDS ---------- */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .stat-card {
          background: #ffffff;
          padding: 20px;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .stat-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
        }

        .stat-card.total .stat-icon { background: #e0e7ff; color: #4338ca; }
        .stat-card.present .stat-icon { background: #dcfce7; color: #166534; }
        .stat-card.absent .stat-icon { background: #fee2e2; color: #991b1b; }
        .stat-card.late .stat-icon { background: #fef9c3; color: #854d0e; }

        .stat-info {
          display: flex;
          flex-direction: column;
        }

        .stat-info span {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .stat-info strong {
          font-size: 24px;
          font-weight: 700;
          color: #0f172a;
          line-height: 1;
        }

        /* ---------- TABLE CONTROLS ---------- */
        .table-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          gap: 16px;
          flex-wrap: wrap;
        }

        .search-box {
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 0 16px;
          flex: 1;
          max-width: 400px;
          transition: border-color 0.2s;
        }

        .search-box:focus-within {
          border-color: #18181b;
        }

        .search-box .fa {
          color: #64748b;
          font-size: 14px;
        }

        .search-box input {
          border: none;
          background: transparent;
          padding: 12px 10px;
          width: 100%;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          outline: none;
        }

        .filter-box {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #64748b;
        }

        .filter-box select {
          padding: 10px 16px;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          background: #ffffff;
          outline: none;
          cursor: pointer;
        }

        /* ---------- DATA TABLE ---------- */
        .table-responsive {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          overflow-x: auto;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }

        .attendance-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }

        .attendance-table th {
          padding: 16px 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .attendance-table td {
          padding: 16px 20px;
          font-size: 14px;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
        }

        .attendance-table tbody tr:last-child td {
          border-bottom: none;
        }

        .attendance-table tbody tr:hover {
          background: #f8fafc;
        }

        .roll-col {
          font-weight: 600;
          color: #64748b;
          width: 80px;
        }

        .name-col {
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #e2e8f0;
          color: #475569;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 700;
        }

        /* Status Badges */
        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 4px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
        }

        .status-badge.present {
          background: #dcfce7;
          color: #166534;
        }

        .status-badge.absent {
          background: #fee2e2;
          color: #991b1b;
        }

        .status-badge.late {
          background: #fef9c3;
          color: #854d0e;
        }

        /* Action Button */
        .btn-toggle {
          background: transparent;
          border: 1px solid #e2e8f0;
          color: #64748b;
          padding: 6px 12px;
          border-radius: 8px;
          font-family: inherit;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }

        .btn-toggle:hover {
          background: #18181b;
          color: #fff;
          border-color: #18181b;
        }

        .no-data {
          text-align: center;
          padding: 40px !important;
          color: #64748b;
          font-style: italic;
        }

        /* ---------- RESPONSIVE ---------- */
        @media (max-width: 768px) {
          .attendance-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .header-actions {
            width: 100%;
            justify-content: space-between;
          }
          
          .search-box {
            max-width: 100%;
          }
          
          .attendance-table th, 
          .attendance-table td {
            padding: 12px 15px;
          }
        }
      `}</style>

      <div className="attendance-page">
        <div className="attendance-container">
          
          {/* HEADER SECTION */}
          <div className="attendance-header">
            <div>
              <h1>Attendance Dashboard</h1>
              <p>Track and manage daily student attendance</p>
            </div>
            <div className="header-actions">
              <input 
                type="date" 
                value={selectedDate} 
                onChange={(e) => setSelectedDate(e.target.value)}
                className="date-picker"
              />
              <button className="btn-primary">Save Attendance</button>
            </div>
          </div>

          {/* STATS CARDS */}
          <div className="stats-grid">
            <div className="stat-card total">
              <div className="stat-icon"><i className="fa fa-users"></i></div>
              <div className="stat-info">
                <span>Total Students</span>
                <strong>{totalStudents}</strong>
              </div>
            </div>
            <div className="stat-card present">
              <div className="stat-icon"><i className="fa fa-check-circle"></i></div>
              <div className="stat-info">
                <span>Present</span>
                <strong>{presentCount}</strong>
              </div>
            </div>
            <div className="stat-card absent">
              <div className="stat-icon"><i className="fa fa-times-circle"></i></div>
              <div className="stat-info">
                <span>Absent</span>
                <strong>{absentCount}</strong>
              </div>
            </div>
            <div className="stat-card late">
              <div className="stat-icon"><i className="fa fa-clock-o"></i></div>
              <div className="stat-info">
                <span>Late</span>
                <strong>{lateCount}</strong>
              </div>
            </div>
          </div>

          {/* FILTER & SEARCH BAR */}
          <div className="table-controls">
            <div className="search-box">
              <i className="fa fa-search"></i>
              <input 
                type="text" 
                placeholder="Search by name or roll no..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="filter-box">
              <label>Class:</label>
              <select value={filterClass} onChange={(e) => setFilterClass(e.target.value)}>
                <option value="All">All Classes</option>
                <option value="10-A">10-A</option>
                <option value="10-B">10-B</option>
                <option value="10-C">10-C</option>
              </select>
            </div>
          </div>

          {/* DATA TABLE */}
          <div className="table-responsive">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Roll No</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((student) => (
                    <tr key={student.id}>
                      <td className="roll-col">{student.roll}</td>
                      <td className="name-col">
                        <div className="avatar">{student.name.charAt(0)}</div>
                        {student.name}
                      </td>
                      <td>{student.class}</td>
                      <td>
                        <span className={`status-badge ${student.status.toLowerCase()}`}>
                          {student.status}
                        </span>
                      </td>
                      <td>
                        <button 
                          className="btn-toggle" 
                          onClick={() => toggleStatus(student.id)}
                          title="Click to toggle status"
                        >
                          <i className="fa fa-refresh"></i> Toggle
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-data">No students found matching your criteria.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </>
  );
};

export default Attendance;